import { decamelizeKeys } from 'humps';
import { bettorrentPost } from '@namespace/helpers';
import { getIp } from '../getRealIp';

export const getBroadcastStream = async ({
  partnerId,
  eventId,
  userId,
  streamId,
  streamType
}) => {
  const userIp = await getIp();

  const result = await bettorrentPost({
    url: '/service/bettorrent/event/broadcast/source',
    mode: 'same-origin',
    body: decamelizeKeys({
      partnerId,
      eventId,
      userId,
      userIp,
      streamId,
      streamType
    })
  });

  return result?.response?.url;
};
